import { Routes } from '@angular/router';

export const PLANNING_PORTAL_ROUTES: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./presentation/presentation.routes').then(
        (p) => p.PRESENTATION_ROUTES
      ),
    data: { breadcrumb: 'Planning Portal' },
  },
];
